import { useSuspenseQuery } from '@apollo/client';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { Link, useParams } from 'react-router-dom';

import { BackBreadcrumbItem } from '@eluve/blocks';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
  Content,
  HStack,
  Header,
  SidebarTrigger,
} from '@eluve/components';
import { ChatWithPatientData } from '@eluve/feature-chat-with-patient-data';
import { getPatientDetailsQuery } from '@eluve/frontend-appointment-hooks';
import { TenantOrUserFeatureFlaggedComponent } from '@eluve/smart-blocks';
import { formatHumanName } from '@eluve/utils';

import { PatientDetailsPage } from './PatientDetailsPage';

export const PatientDetailsPageLayout: React.FC<{ baseUrl: string }> = ({
  baseUrl,
}) => {
  const { tenantId, patientId } = useParams() as {
    tenantId: string;
    patientId: string;
  };
  const { data } = useSuspenseQuery(getPatientDetailsQuery, {
    variables: {
      tenantId,
      patientId,
    },
  });
  const basicDetails = data?.patientsByPk;

  return (
    <>
      <Header>
        <SidebarTrigger />
        <Breadcrumb className="flex-1">
          <BreadcrumbList>
            <BackBreadcrumbItem />
            <BreadcrumbItem>
              <Link to={`/organizations/${tenantId}/patients`}>Patients</Link>
            </BreadcrumbItem>

            <BreadcrumbSeparator>/</BreadcrumbSeparator>
            <BreadcrumbItem className="text-text-primary privacy-text">
              {basicDetails?.firstName
                ? formatHumanName(basicDetails.firstName, basicDetails.lastName)
                : 'Loading...'}
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <HStack justify="end" wFull={false}>
          <TenantOrUserFeatureFlaggedComponent flag="INSIGHTS_CHAT">
            <ChatWithPatientData
              tenantId={tenantId}
              patientId={patientId}
              baseUrl={baseUrl}
            />
          </TenantOrUserFeatureFlaggedComponent>
        </HStack>
      </Header>
      <Content padded>
        <ErrorBoundary fallback={<div>Error</div>}>
          <PatientDetailsPage />
        </ErrorBoundary>
      </Content>
    </>
  );
};
